module.exports = __webpack_public_path__ + "assets/retina_SumSquaresDetailed.07b36aedbf5ec447889cf2af28b36e52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SumSquaresDetailed.png
// module id = 725
// module chunks = 0